<template>
	<div class="little-card md-elevation-4">
		<div style="font-size: 18px; display: flex">
			<span style="margin-left: 0; margin-right: auto">
				{{ $t("total-rewards") }}
			</span>
		</div>
		<div style="display: flex; margin-top: 5px">
			<md-progress-spinner
				v-if="payments.totalAmount === undefined"
				md-mode="indeterminate"
				:md-diameter="30"
				:md-stroke="3"
				class="md-accent"
			/>
			<md-icon v-else class="md-size-2x" style="color: #66bb6a; margin-top: auto; margin-bottom: auto"
				>euro</md-icon
			>
			<span
				style="
					font-size: 32px;
					font-weight: 900;
					margin-left: auto;
					margin-right: 0px;
					margin-top: auto;
					margin-bottom: auto;
				"
			>
				{{ payments.totalAmount ? payments.totalAmount.toFixed(2) : 0 }}
			</span>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
export default {
	name: "payment-card",
	computed: {
		...mapGetters({
			payments: "dashboard/paymentsNumber"
		})
	}
}
</script>

<style scoped lang="scss">
.little-card {
	width: 100%;
	height: 100%;
	margin-bottom: 10px;
	padding: 20px;
	border-radius: 15px;
	margin: 5px;
	color: #66bb6a;
}
span {
	font-family: "Montserrat", sans-serif;
}
</style>
